import { type DocumentNode } from 'graphql'
import { isApolloError } from '@apollo/client'
import GraphQLAggregateError from '../common/errors/GraphQLAggregateError'
import { fetchRetailersClient } from './dashboardClient'

const createMutation =
  <D, V>(mutation: DocumentNode) =>
  async (variables: V): Promise<D> => {
    try {
      const { data } = await fetchRetailersClient().mutate<D, V>({
        mutation,
        variables,
      })

      if (data) {
        return data
      }

      throw new Error('Unexpected Error')
    } catch (err) {
      // The "mutate" function doesn't return an errors key, it raises if there is an error
      // We can handle it an re-package it into a GraphQLAggregateError
      if (isApolloError(err)) {
        throw new GraphQLAggregateError(err.graphQLErrors)
      }

      // Re-raise original error
      throw err
    }
  }

export default createMutation
